import "core-js/modules/es.array.concat";
export var enumHelper = function enumHelper(enumName, enumMap, field) {
  if (!enumMap[field]) {
    throw new TypeError("".concat(field, " is not a valid field of ").concat(enumName));
  }

  if (arguments.length <= 3 ? 0 : arguments.length - 3) {
    return (arguments.length <= 3 ? undefined : arguments[3]) === enumMap[field];
  }

  return enumMap[field];
};